"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const angular_1 = __importDefault(require("angular"));
const applicationConfiguration_provider_1 = require("../../xccti/services/applicationConfiguration.provider");
class ThirdPartyController {
    constructor($scope, $log, XucThirdPartyService, remoteConfiguration, electronWrapper, ExternalEvent, $window, applicationConfiguration) {
        this.$scope = $scope;
        this.$log = $log;
        this.XucThirdPartyService = XucThirdPartyService;
        this.remoteConfiguration = remoteConfiguration;
        this.electronWrapper = electronWrapper;
        this.ExternalEvent = ExternalEvent;
        this.$window = $window;
        this.applicationConfiguration = applicationConfiguration;
        this.appConfig = applicationConfiguration.getCurrentAppConfig();
        remoteConfiguration.get("thirdPartyWsUrl").then((value) => {
            if (value.length > 0) {
                this.XucThirdPartyService.setThirdPartyWs(value);
                this.ExternalEvent.registerThirdPartyCallback(this.onMessageReceived.bind(this));
                this.XucThirdPartyService.addActionHandler(this.$scope, this.onThirdPartyAction.bind(this));
                this.XucThirdPartyService.addClearHandler(this.$scope, this.onThirdPartyClearAction.bind(this));
            }
        });
    }
    isSwitchboard() {
        return this.appConfig.appType == applicationConfiguration_provider_1.AppType.Switchboard ? "thirdparty-switchboard" : " ";
    }
    onMessageReceived() {
        this.XucThirdPartyService.clearAllActions();
    }
    onThirdPartyAction(event) {
        switch (event.action) {
            case 'open': {
                this.$scope.action = event;
                this.electronWrapper.setElectronFullscreen();
                let btn = angular_1.default.element('#maxmin-btn');
                if (btn.length) {
                    btn.addClass('hide');
                }
                break;
            }
            case 'popup': {
                if (angular_1.default.isDefined(event.url)) {
                    let windowName = 'popup';
                    if (angular_1.default.isDefined(event.multitab) && event.multitab) {
                        windowName = windowName + lodash_1.default.uniqueId();
                    }
                    this.$window.open(event.url, windowName);
                }
                break;
            }
            case 'run': {
                if (angular_1.default.isDefined(event.url)) {
                    let args = [];
                    if (angular_1.default.isDefined(event.executableArgs)) {
                        args = event.executableArgs;
                    }
                    this.electronWrapper.runExecutable(event.url, args);
                }
            }
        }
    }
    onThirdPartyClearAction() {
        this.$scope.action = null;
        this.electronWrapper.setElectronConfig({
            width: this.electronWrapper.ELECTRON_AGENT_DEFAULT_WIDTH,
            height: this.electronWrapper.ELECTRON_AGENT_DEFAULT_HEIGHT
        });
        let btn = angular_1.default.element('#maxmin-btn');
        if (btn.length) {
            btn.removeClass('hide');
        }
    }
}
exports.default = ThirdPartyController;
